import {Component, MeshComponent, Object3D, WonderlandEngine} from '@wonderlandengine/api';
import {SoundManagerInstance, Sounds} from '../managers/soundmanager.js';
import {property} from '@wonderlandengine/api/decorators.js';
import {KillerAnimationController} from './killer-animation-controller.js';
import {Blink} from './blink.js';
import {Locomotion} from './locomotion.js';
import {SnapRotate} from './snap-rotate.js';
import {GameManagerInstance, SceneNames} from '../managers/gamemanager.js';
import {WasdControlsFps} from './wasd-controls-fps.js';
/**
 * Sequence for the Laughing man.
 *
 * Details:
 * | step | time | action |
 * | --- | --- | :-- |
 * | 0 | 0 | Play 'boom1' sound |
 * | 0 | 0 | Play 'LaughingManMedium' sound |
 * | 0 | 0 | Start looking animation |
 * | 1 | 1 | Start running animation |
 * | 2 | 2 | Start Fade out (.5s) |
 * | 3 | 3.5 | Play 'Knife' sound |
 * | 4 | 8 | End sequence |
 */
export class LaughingManSequence extends Component {
    static TypeName = 'laughing-man-sequence';

    static onRegister(engine: WonderlandEngine) {
        engine.registerComponent(KillerAnimationController);
    }

    @property.object({required: true})
    locomotionObject!: Object3D;
    @property.object({required: true})
    snapRotateObject!: Object3D;
    @property.object({required: true})
    wasdLocomotionObject!: Object3D;

    @property.object({required: true})
    blinkObject!: Object3D;

    @property.object({required: true})
    animationControllerObject!: Object3D;

    private step = 0;
    private time = 0;
    private bodyMeshComponent?: MeshComponent;
    private animationController?: KillerAnimationController;
    private blinkComponent?: Blink;
    private locomotion?: Locomotion;
    private snapRotate?: SnapRotate;
    private wasdComponent?: WasdControlsFps;

    start() {
        const tempBlinkComponent = this.blinkObject.getComponent(Blink);
        if (!tempBlinkComponent) {
            throw new Error(
                `laughing-man-sequence(${this.object.name}): blinkObject does not have a BlinkComponent`
            );
        }
        this.blinkComponent = tempBlinkComponent;

        const tempAnimationController = this.animationControllerObject.getComponent(
            KillerAnimationController
        );
        if (!tempAnimationController) {
            throw new Error(
                `laughing-man-sequence(${this.object.name}): animationControllerObject does not have a AnimationController`
            );
        }
        this.animationController = tempAnimationController;

        const tempLocomotion = this.locomotionObject.getComponent(Locomotion);
        if (!tempLocomotion) {
            throw new Error(
                `laughing-man-sequence(${this.object.name}): locomotionObject does not have a Locomotion`
            );
        }
        this.locomotion = tempLocomotion;

        const tempSnapRotate = this.snapRotateObject.getComponent(SnapRotate);
        if (!tempSnapRotate) {
            throw new Error(
                `laughing-man-sequence(${this.object.name}): snapRotateObject does not have a SnapRotate`
            );
        }
        this.snapRotate = tempSnapRotate;

        const tempWasdComponent = this.wasdLocomotionObject.getComponent(WasdControlsFps);
        if (!tempWasdComponent) {
            throw new Error(
                `laughing-man-sequence(${this.object.name}): wasdLocomotionObject does not have a WasdComponent`
            );
        }
        this.wasdComponent = tempWasdComponent;
    }

    update(delta: number): void {
        this.time += delta;

        if (this.step == 1 && this.time > 1) {
            this.step = 2;
            this.animationController!.playSearchLeft();
        }
        if (this.step == 2 && this.time > 2.5) {
            this.animationController!.playWalk();
            this.blinkComponent!.blinkTime = 0.75;
            this.blinkComponent!.startBlink(null, null, false, null, true);
            SoundManagerInstance.playSound(Sounds.KillerMoveFast);
            this.step = 3;
        }
        if (this.step == 3 && this.time > 3.5) {
            SoundManagerInstance.stopSound(Sounds.KillerMoveFast);
            SoundManagerInstance.playSound(Sounds.Knife);
            this.step = 4;
        }
        if (this.step == 4 && this.time > 8) {
            this.step = -1;
            GameManagerInstance.loadScene(SceneNames.Scene2Opening);
        }
    }

    startSequence() {
        this.locomotion!.active = false;
        this.snapRotate!.active = false;
        this.wasdComponent!.active = false;

        this.time = 0;
        SoundManagerInstance.playSound(Sounds.boom1);
        SoundManagerInstance.playSound(Sounds.LaughingManMedium);

        this.bodyMeshComponent!;
        this.step = 1;
        this.time = 1;
    }
}
